<template>
  <header class="header">
    <div class="header-container">
      <!-- Logo y navegación izquierda -->
      <div class="header-left">
        <div class="logo">
          <img src="/fourin.png" alt="Fourin Logo" />
        </div>

        <!-- 1. NAVEGACIÓN DE ESCRITORIO (SE OCULTA EN MÓVIL) -->
        <nav class="nav-links desktop-nav">
          <router-link
            to="/"
            class="nav-link"
            :class="{ active: $route.path === '/' }"
            @click="logClick('Inicio', '/')"
          >
            Inicio
          </router-link>
          <router-link
            to="/products"
            class="nav-link"
            :class="{ active: $route.path === '/products' }"
            @click="logClick('Productos', '/products')"
          >
            Productos
          </router-link>
          <router-link to="/blog" class="nav-link" @click="logClick('Blog', '/blog')">
            Blog
          </router-link>
          <router-link to="/ebook" class="nav-link" @click="logClick('Ebook', '/ebook')">
            Ebook
          </router-link>
          <router-link to="/about" class="nav-link" @click="logClick('¿Quienes somos?', '/about')">
            ¿Quienes somos?
          </router-link>
        </nav>
      </div>

      <!-- Contacto e inicio de sesión derecha -->
      <div class="header-right">
        <!-- 2. BOTONES DE ESCRITORIO (SE OCULTAN EN MÓVIL) -->
        <router-link
          to="/contact"
          class="contact-link desktop-link"
          @click="logClick('Contáctanos', '/contact')"
        >
          Contáctanos
        </router-link>
        <a
          href="https://ftrack.4in.online/"
          class="login-button desktop-link"
          @click="logClick('Inicia sesión', 'https://ftrack.4in.online/')"
        >
          Inicia sesión
        </a>

        <!-- 3. BOTÓN DE HAMBURGUESA (SOLO EN MÓVIL) -->
        <button
          class="hamburger"
          @click="toggleMenu"
          aria-label="Abrir menú"
          :class="{ 'is-active': isMenuOpen }"
        >
          <span class="hamburger-box">
            <span class="hamburger-inner"></span>
          </span>
        </button>
      </div>
    </div>

    <!-- 4. MENÚ MÓVIL DESPLEGABLE -->
    <transition name="slide-down">
      <div v-if="isMenuOpen" class="mobile-menu">
        <nav class="mobile-nav-links">
          <router-link to="/" class="mobile-nav-link" @click="closeMenu"> Inicio </router-link>
          <router-link to="/blog" class="mobile-nav-link" @click="closeMenu"> Blog </router-link>
          <router-link to="/ebook" class="mobile-nav-link" @click="closeMenu"> Ebook </router-link>
          <router-link to="/about" class="mobile-nav-link" @click="closeMenu">
            ¿Quienes somos?
          </router-link>
          <router-link to="/contact" class="mobile-nav-link" @click="closeMenu">
            Contáctanos
          </router-link>
        </nav>
        <div class="mobile-actions">
          <router-link to="/login" class="mobile-login-button" @click="closeMenu">
            Inicia sesión
          </router-link>
        </div>
      </div>
    </transition>
  </header>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const isMenuOpen = ref(false)

const logClick = (linkName: string, path: string) => {
  console.log(`🔗 Click en: ${linkName} -> ${path}`)
  console.log(`📍 Ruta actual: ${route.path}`)
  console.log(`🔄 Navegando a: ${path}`)

  // Verificar si la ruta es diferente a la actual
  if (route.path !== path) {
    console.log(`✅ Navegación válida - ruta diferente`)
  } else {
    console.log(`⚠️ Ya estás en esta ruta`)
  }
}

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value
  // Opcional: Evitar el scroll del body cuando el menú está abierto
  document.body.style.overflow = isMenuOpen.value ? 'hidden' : ''
}

const closeMenu = () => {
  isMenuOpen.value = false
  document.body.style.overflow = ''
}
</script>

<style scoped>
.header {
  height: 90px;
  background: white;
  border-bottom: 2px solid #e2e8f0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 40px;
}

.logo img {
  height: 40px;
  width: auto;
}

.nav-links {
  display: flex;
  gap: 30px;
}

.nav-link {
  text-decoration: none;
  color: #333;
  font-size: 16px;
  font-weight: 600;
  transition: color 0.3s ease;
}

.nav-link:hover {
  color: #129bef;
}

.nav-link.active {
  color: #129bef;
  border-bottom: 2px solid #129bef;
  padding-bottom: 2px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 30px;
}

.contact-link {
  text-decoration: none;
  color: #333;
  font-size: 16px;
  font-weight: 600;
  transition: color 0.3s ease;
}

.contact-link:hover {
  color: #129bef;
}

.login-button {
  background: #129bef;
  color: white;
  text-decoration: none;
  padding: 10px 24px;
  border-radius: 58px;
  font-size: 16px;
  font-weight: 500;
  transition: background-color 0.3s ease;
}

.login-button:hover {
  background: #1d4ed8;
}

/* Responsive */
@media (max-width: 768px) {
  .header-container {
    padding: 0 15px;
  }

  .header-left {
    gap: 20px;
  }

  .nav-links {
    gap: 20px;
  }

  .header-right {
    gap: 20px;
  }

  .nav-link,
  .contact-link {
    font-size: 14px;
  }

  .login-button {
    padding: 10px 20px;
    font-size: 14px;
  }
}

/* -------------------------------------- */
/* HAMBURGUESA Y MENÚ MÓVIL ESTILOS */
/* -------------------------------------- */

.hamburger {
  display: none; /* Oculto por defecto, visible solo en móvil */
  padding: 0;
  cursor: pointer;
  background-color: transparent;
  border: 0;
  margin: 0;
  z-index: 1010;
}

.hamburger-box {
  width: 24px;
  height: 24px;
  display: inline-block;
  position: relative;
}

.hamburger-inner {
  display: block;
  top: 50%;
  margin-top: -2px;
}

.hamburger-inner,
.hamburger-inner::before,
.hamburger-inner::after {
  width: 24px;
  height: 2px;
  background-color: #333;
  border-radius: 4px;
  position: absolute;
  transition:
    transform 0.3s ease-in-out,
    opacity 0.3s ease-in-out;
}

.hamburger-inner::before,
.hamburger-inner::after {
  content: '';
  display: block;
}

.hamburger-inner::before {
  top: -8px;
}

.hamburger-inner::after {
  bottom: -8px;
}

/* Transformación de la X */
.hamburger.is-active .hamburger-inner {
  transform: rotate(45deg);
}
.hamburger.is-active .hamburger-inner::before {
  top: 0;
  opacity: 0; /* Oculta la línea superior */
}
.hamburger.is-active .hamburger-inner::after {
  bottom: 0;
  transform: rotate(-90deg); /* Rota la línea inferior para formar la X */
}

/* MENÚ DESPLEGABLE */
.mobile-menu {
  position: absolute;
  top: 90px; /* Debajo del header */
  left: 0;
  width: 100%;
  background: white;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  padding: 20px 0;
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.mobile-nav-links {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0px 20px;
  width: 100%;
}

.mobile-nav-link {
  text-decoration: none;
  color: #333;
  font-size: 18px;
  font-weight: 600;
  padding: 10px 0;
  border-bottom: 1px solid #e2e8f0;
}

.mobile-actions {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px 20px;
  gap: 10px;
}

.mobile-contact-link {
  text-align: center;
  color: #129bef;
  text-decoration: none;
  font-weight: 600;
  padding: 10px;
}

.mobile-login-button {
  text-align: center;
  background: #129bef;
  color: white;
  text-decoration: none;
  padding: 12px;
  border-radius: 50px;
  font-size: 16px;
  font-weight: 500;
}

/* VUE TRANSITION CLASSES */
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease-in-out;
}
.slide-down-enter-from,
.slide-down-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}

/* -------------------------------------- */
/* MEDIA QUERIES FINALES */
/* -------------------------------------- */

@media (max-width: 1024px) {
  /* Ocultar enlaces de escritorio en pantallas medianas/pequeñas */
  .desktop-nav,
  .desktop-link {
    display: none;
  }

  /* Mostrar la hamburguesa */
  .hamburger {
    display: block;
  }

  /* Reducir el padding del contenedor del header */
  .header-container {
    padding: 0 15px;
  }
}

@media (max-width: 768px) {
  /* Podemos reducir la altura del header en móvil si es necesario */
  .header {
    height: 70px;
  }
  .mobile-menu {
    top: 70px; /* Ajustar la posición de inicio del menú */
  }
  .logo img {
    height: 30px; /* Logo más pequeño */
  }
}
</style>
